import PropTypes from 'prop-types';
import classNames from 'classnames';
import Grid from '@mui/material/Grid';
import SnapshotGrid from './Snapshot/SnapshotGrid';

function Snapshot({
  className = '',
  mediaFormat = 'audio',
  playlists = [],
  mixes = [],
  messageBlocks = [],
  interruptions = [],
  loops = [],
  disabled = false,
  onClickDay = () => {},
}) {
  return (
    <div className={classNames('Snapshot', className)}>
      <Grid spacing={2} container>
        <Grid size={12}>
          <SnapshotGrid
            mediaFormat={mediaFormat}
            playlists={playlists}
            mixes={mixes}
            messageBlocks={messageBlocks}
            interruptions={interruptions}
            loops={loops}
            disabled={disabled}
            onClickDay={onClickDay}
          />
        </Grid>
      </Grid>
    </div>
  );
}

Snapshot.propTypes = {
  className: PropTypes.string,
  mediaFormat: PropTypes.oneOf([
    'audio',
    'visual',
  ]),
  playlists: PropTypes.arrayOf(PropTypes.object),
  mixes: PropTypes.arrayOf(PropTypes.object),
  messageBlocks: PropTypes.arrayOf(PropTypes.object),
  interruptions: PropTypes.arrayOf(PropTypes.object),
  loops: PropTypes.arrayOf(PropTypes.object),
  disabled: PropTypes.bool,
  onClickDay: PropTypes.func,
};

export default Snapshot;
